import {
  LayoutDashboard,
  Calendar,
  Users,
  Users2,
  Globe,
  UserPlus,
  Dumbbell,
  Briefcase,
  DollarSign,
  BarChart3,
  Building2,
  UsersRound,
  Settings,
  Shield,
  LogOut,
  Pencil,
  Megaphone,
  Video,
  TrendingUp,
  MessageCircle,
  ListChecks,
  LayoutTemplate,
  ClipboardList,
  Receipt,
  Link2,
  FileSpreadsheet,
  Palette,
  Phone,
  // Marketing icons
  Sparkles,
  Send,
  FileDown,
  Zap,
  AtSign,
  PieChart,
  BrainCircuit,
  Lightbulb,
  Bot,
  Gift,
  UserCircle,
  Images,
  FlaskConical,
  Calculator,
  Plug,
  Home,
  type LucideIcon,
} from "lucide-react";

export const ICON_MAP: Record<string, LucideIcon> = {
  LayoutDashboard,
  Calendar,
  Users,
  Users2,
  Globe,
  UserPlus,
  Dumbbell,
  Briefcase,
  DollarSign,
  BarChart3,
  Building2,
  UsersRound,
  Settings,
  Shield,
  LogOut,
  Pencil,
  Megaphone,
  Video,
  TrendingUp,
  MessageCircle,
  ListChecks,
  LayoutTemplate,
  ClipboardList,
  Receipt,
  Link2,
  FileSpreadsheet,
  Palette,
  Phone,
  // Marketing icons
  Sparkles,
  Send,
  FileDown,
  Zap,
  AtSign,
  PieChart,
  BrainCircuit,
  Lightbulb,
  Bot,
  Gift,
  UserCircle,
  Images,
  FlaskConical,
  Calculator,
  Plug,
  Home,
};

export type IconName = keyof typeof ICON_MAP;

export function getIcon(name: string): LucideIcon | undefined {
  return ICON_MAP[name];
}
